<div class="row column">
    <div class="shop-download">
        <div class="donation-wrapper">
            <h2>{{ 'shop.brochure.donation' | translate }}</h2>
            <p [innerHTML]="'shop.brochure.donation.info' | translate"></p>
            <amount [donation]="digitalDownloadDonation" [form]="form"></amount>
            <button class="button hollow arrow arrow-right" (click)="startDonation()" [innerHTML]="'shop.download.donate.now.button' |  translate "></button> 
        </div>
    </div>
</div>
